<script setup>
import axios from 'axios';
import { urlMainAPI } from "@/global";
import FaultTree from "../../manageOccurrenceHandling/template/FaultTree.vue";
import { faultTreeMixin } from "../../mixins/faultTreeMixin";
import searchDatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ptbr from 'vue2-datepicker/locale/pt-br'
</script>
<template>
    <section>
        <b-overlay class="main" id="overlay-background" :show="loadingAction" rounded="sm">
            <FaultTree v-if="this.reasonTreeId != null && this.loadingAction == false" class="actionTreeContainer"
                :editable="false" :getTree="0" :data="this.actionTree" @nodeDbClick="setActionFromTree($event)" />
            <section v-if="this.reasonTreeId == null && this.loadingAction == false" class="hasNotTree">
                <p>O motivo selecionado não está presente na <strong>Árvore de Falhas</strong> e, portanto, não possui
                    uma árvore de ações.</p>
                <p>Crie uma ação personalizada abaixo:</p>
                <textarea id="" rows="3" v-model="selectedActionFromTree.actionOtherDescription"></textarea>
            </section>

            <section class="actionSelected">
                <p>Ação Selecionada: <span>{{ this.selectedActionFromTree.action
                        }}</span></p>
            </section>

            <section v-if="this.reasonTreeId != null && this.loadingAction == false">
                <input type="checkbox" id="addOthersDesc" v-model="selectedActionFromTree.hasOtherDesc"
                    :disabled="disableCheck">
                <label for="addOthersDesc">{{ this.$t('add-detailed-action') }}</label>
            </section>

            <section class="otherActionContainer"
                v-if="this.reasonTreeId != null && this.selectedActionFromTree.hasOtherDesc && this.selectedActionFromTree.hasOtherDesc == true">
                <label for="otherAction">Descrição da Ação:</label>
                <textarea id="otherAction" rows="2" v-model="selectedActionFromTree.actionOtherDescription"
                    placeholder="Descreva a outra ação aqui."></textarea>
            </section>
            <hr />
            <section class="setDeadline" v-if="this.showDeadlineSection == true">
                <b-form-checkbox v-model="checkDeadLine" name="check-button" switch>
                    <span>{{ $t('add-with-deadline') }}</span>
                </b-form-checkbox>
            </section>

            <section class="otherActionInfos" v-if="this.showDeadlineSection == true && checkDeadLine == true">
                <label for="responsibleSelect">
                    <span>Responsável:</span>
                    <select id="responsibleSelect" v-model="actionResponsibleId">
                        <option disabled selected value="" class="defaultopt">Selecione um responsável</option>
                        <option v-for="responsible in this.responsiblesList"
                            :key="`${responsible.id}-${responsible.unitId}-${responsible.system}`"
                            :value="responsible.id">
                            {{
                                responsible.name }}</option>
                    </select>
                </label>
                <label for="deadline" v-if="checkDeadLine == true">
                    <span>Prazo:</span>
                    <searchDatePicker :lang="ptbr" v-model="deadlineDate" class="custom-date" type="date"
                        format="DD/MM/YYYY" placeholder="Intervalo da busca" id="deadline" />
                </label>
            </section>

        </b-overlay>
        <section class="addButtons">
            <button class="withDeadline" v-if="this.showDeadlineSection == true && checkDeadLine == true" @click="applyAction(false)">{{
                this.$t('confirm-schedule') }}</button>
            <button class="cancel" @click="closeModal">{{ this.$t('cancel')
                }}</button>
            <button @click="applyAction(true)" :disabled="checkDeadLine">{{ this.$t('add-without-deadline') }}</button>
        </section>
    </section>
</template>
<script>
export default {
    name: "ActionsToSelect",
    props: ["actionObj", "indicatorId", "userObj", "reasonTreeId", "reasonId", "addActionFunction", "responsiblesList", "showActionResponsible", "occurrenceResponsible", "needDeadline", "modalId"],
    components: { FaultTree, searchDatePicker },
    mixins: [faultTreeMixin],
    data() {
        return {
            actionTree: {},
            actionCreated: {},
            selectedActionFromTree: {},
            loadingAction: false,
            deadlineDate: new Date(),
            actionResponsible: {},
            actionResponsibleId: null,
            disableCheck: false,
            checkDeadLine: false,
            showDeadlineSection:false,
        }
    },
    methods: {
        async getActionTree(indicatorId, user, reasonTreeId) {
            await axios
                .get(`${urlMainAPI}/getdecisiontree/${indicatorId}/${user.UnitId}/${user.onlineType[0]}/${reasonTreeId}`)
                .then((res) => {
                    if (res.data) {
                        this.actionTree = this.copyFrom(res.data)
                        if (this.actionTree.state && this.actionTree.state.expanded) this.actionTree.state.expanded = true;
                    }
                })
                .catch(err => console.error(err));
        },

        setActionFromTree(event) {
            let actionObj = {
                action: event.path,
                id: event.node.id,
                actionTreeId: event.node.id,
                createdBy: this.userObj.Id,
                hasOtherDesc: event.node.data.text.toLowerCase() == 'outros' || event.node.data.text.toLowerCase() == 'outro' || event.node.data.text.toLowerCase().includes('outro') ? true : false,
                actionOtherDescription: '',
            }

            if (event.node.data.text.toLowerCase() == 'ações' || event.node.data.text.toLowerCase() == 'outros' || event.node.data.text.toLowerCase() == 'outro' || event.node.data.text.toLowerCase().includes('outro')) {
                actionObj.hasOtherDesc = true;
                this.disableCheck = true;
            } else {
                this.disableCheck = false;
            }

            this.selectedActionFromTree = actionObj
        },

        applyAction(ignoreDeadline) {
            if (ignoreDeadline == true) {
                this.actionResponsible = {
                    email: '',
                    id: this.userObj.Id,
                    name: this.userObj.FullName,
                    system: this.userObj.onlineType[0],
                    unitId: this.userObj.UnitId,
                    receiveAutonomousWarning: true
                }
            }
            else this.actionResponsible = this.responsiblesList.find(item => item.id == this.actionResponsibleId)

            if (!this.selectedActionFromTree.action || this.actionResponsible === null || (this.selectedActionFromTree.hasOtherDesc == true && this.selectedActionFromTree.actionOtherDescription == '')) {
                this.$bvToast.toast('Preencha todos os campos antes de adicionar uma ação.', {
                    title: 'Campos vazios!',
                    variant: 'warning',
                    toaster: 'b-toaster-bottom-left',
                    solid: true
                });

                return;
            }

            if (this.selectedActionFromTree.hasOtherDesc == true) this.selectedActionFromTree.action += ` : ${this.selectedActionFromTree.actionOtherDescription}`;

            let formatedDate = new Date(this.deadlineDate).toLocaleDateString("pt-Br")

            let actionObj = {
                action: this.selectedActionFromTree.action,
                closingDate: null,
                date: formatedDate,
                reasonId: this.reasonId,
                createdBy: this.userObj.Id,
                responsableId: this.actionResponsible.id,
                responsableSystem: this.actionResponsible.system,
                responsableUnitId: this.actionResponsible.unitId,
                status: null,
                responsableName: this.actionResponsible.name,
                actionId: this.actionObj.actionId ? this.actionObj.actionId : Math.random()
            }

            if (ignoreDeadline == true) {
                actionObj.closingDate = new Date().toLocaleDateString("pt-Br");
                actionObj.status = "Concluída";
            }

            this.addActionFunction(actionObj, this.reasonId);
            this.$bvModal.hide('selectActionTree');
        },
        closeModal() {
            if (this.modalId) {
                this.$bvModal.hide(this.modalId);
            } else {
                this.$bvModal.hide('selectActionTree');
            }
        }
    },

    async created() {
        if (this.reasonTreeId != null && this.reasonTreeId != undefined && this.indicatorId != null) {
            this.loadingAction = true;
            await this.getActionTree(this.indicatorId, this.userObj, this.reasonTreeId);
        } else {
            this.selectedActionFromTree = {
                action: 'Outros',
                id: null,
                actionTreeId: null,
                createdBy: '',
                hasOtherDesc: true,
                actionOtherDescription: '',
            }
        }

        this.loadingAction = false;
    },

    mounted() {
        //this.checkDeadLine = this.needDeadline;

        if(this.userObj && this.userObj.Permissions && this.userObj.Permissions.criaracaocomprazo && this.userObj.Permissions.criaracaocomprazo.allowed == true){
            this.showDeadlineSection = true;
        }

        if (this.actionObj.actionId) {
            this.selectedActionFromTree.id = this.actionObj.actionId;

            let actionParts = this.actionObj.action.split(" : ");
            let baseAction = actionParts[0];
            let additionalDescription = actionParts.length > 1 ? actionParts.slice(1).join(" : ") : '';


            if (baseAction.toLowerCase().includes('outros') || baseAction.toLowerCase().includes('outro')) {
                this.selectedActionFromTree = {
                    action: baseAction.trim(),
                    id: this.actionObj.actionId,
                    actionTreeId: this.actionObj.actionTreeId,
                    createdBy: this.userObj.Id,
                    hasOtherDesc: true,
                    actionOtherDescription: additionalDescription,
                };
                this.disableCheck = true;
            } else {
                this.selectedActionFromTree = {
                    action: baseAction.trim(),
                    id: this.actionObj.actionId,
                    actionTreeId: this.actionObj.actionTreeId,
                    createdBy: this.userObj.Id,
                    hasOtherDesc: additionalDescription ? true : false,
                    actionOtherDescription: additionalDescription,
                };
                this.disableCheck = false;
            }


            this.actionResponsible = {
                email: '',
                id: this.actionObj.responsableId,
                name: this.actionObj.responsableName,
                system: this.actionObj.responsableSystem,
                unitId: this.actionObj.responsableUnitId,
                receiveAutonomousWarning: true
            };

            this.actionResponsibleId = this.actionObj.responsableId;

            if (this.actionObj.date != null && this.actionObj.date.includes('/')) {
                const parts = this.actionObj.date.split("/");
                if (parts.length === 3) {
                    let day = parseInt(parts[0], 10);
                    let month = parseInt(parts[1], 10) - 1;
                    let year = parseInt(parts[2], 10);
                    this.deadlineDate = new Date(year, month, day);
                }
            }
        }
    }



}
</script>
<style scoped>
.actionTreeContainer {
    padding: 0.3rem;
    border: 1px solid #bebebe;
    border-radius: 0.2rem;
    height: max-content;
    max-height: 16rem;
}

.actionSelected {
    display: flex;
    align-items: center;
    column-gap: 0.3rem;
    margin-top: 0.5rem;
}

.actionSelected p,
.setDeadline span {
    font-weight: bold;
    margin: 0;
}

.actionSelected span {
    font-weight: normal;
}

.setDeadline {
    display: flex;
    align-items: flex-start;

    column-gap: 0.8rem;
}

.otherActionContainer {
    margin-top: 0.3rem;
}

.otherActionContainer label {
    font-weight: bold;
}

.otherActionContainer textarea {
    width: 100%;
}

.defaultopt {
    color: #999999;
}

.otherActionInfos {
    margin-top: 0.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 2rem;
}

.otherActionInfos label {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 0.3rem;
}

.otherActionInfos label:first-child {
    width: 100%;
}

.otherActionInfos label span {
    font-weight: bold;
}

.responsibleSelect {
    width: 100%;
}

.otherActionInfos select {
    width: 100%;
    border: 1px solid rgb(187, 187, 187);
    border-radius: 0.2rem;
    padding: 0.2rem;
}

.hasNotTree {
    width: 100%;
}

.hasNotTree p {
    margin: 0;
    padding: 0;
}

.hasNotTree textarea {
    width: 100%;
}


.addButtons {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    column-gap: 1rem;
}

.addButtons button {
    font-weight: bold;
    padding: 0.4rem 0.5rem;
    color: white;
    background-color: #ff5f00;
    border: none;
    border-radius: 0.2rem;
    font-size: 0.9rem;
}

.addButtons .cancel {
    background-color: #5a6268;
}

.addButtons .withDeadline {
    background-color: #17a2b8;
    display: block;
    margin-right: auto;
}

button[disabled="disabled"] {
    background-color: #5a6268;
    user-select: none;
    cursor: not-allowed;
}

#addOthersDesc {
    margin-right: 0.3rem;
}
</style>